import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggingService } from '../logging/logging.service';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateRewardModel, DropDownSocialLink, EditRewardModel, Reward, RewardPlansModel, TagRewardModel } from '../../models/inModels/Rewards';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class RewardsService {
	private routeReward = '/api/rewards';

	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Reward> {
		return this.http.get(`${this.auth.apiUrl}${this.routeReward}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Reward)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateRewardModel): Promise<Reward> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Reward)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditRewardModel): Promise<Reward> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Reward)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeReward}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	tagReward(model: TagRewardModel): Promise<Reward> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/tag`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Reward)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/dropdown`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	clearReward(model: TagRewardModel): Promise<Reward> {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/clearTags`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Reward)
			.catch(error => this.logging.handleError(error));
	}

	updatePlan(model: RewardPlansModel) {
		return this.http.post(`${this.auth.apiUrl}${this.routeReward}/plan`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	removePlan(rewardId: number, planId: number) {
		return this.http.delete(`${this.auth.apiUrl}${this.routeReward}/plan/${rewardId}/${planId}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getSocialLinks(): Promise<DropDownSocialLink[]> {
		return this.http.get<DropDownSocialLink[]>(`${this.auth.apiUrl}${this.routeReward}/sociallinks`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	
	
}



// WEBPACK FOOTER //
// ./src/app/services/rewards/rewards.service.ts